var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-zip h-100"},[_c('zip-files',{attrs:{"bgu":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }